import { CollapsibleCard, StatusObject } from '@yes.technology/react-toolkit'
import { ALL_SUBORDERS_TYPES } from 'component/TransferOrderCard/constants'
import { TransferOrder } from 'component/TransferOrderCard/types'
import { SectionTitle } from 'component/TransportOrderCard/TransportOrderCard.styles'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18n-lite'
import { useStatuses } from 'status/shared'
import { useFetchYesObjects } from 'yesObject/shared'
import { Checkpoint } from '../../types'
import CheckpointCard from '../CheckpointCard/CheckpointCard'
import { Container } from './styles'

interface CheckpointsSectionProps {
  checkpoints: Checkpoint[]
  ordersToUse?: string[]
}

const EMPTY_ARRAY: string[] = []

function CheckpointsSection({
  checkpoints,
  ordersToUse = EMPTY_ARRAY
}: CheckpointsSectionProps) {
  const { t } = useTranslation()

  const ordersToRemove = useMemo(() => {
    const ordersToUseSet = new Set(ordersToUse)

    return ALL_SUBORDERS_TYPES.filter((order) => !ordersToUseSet.has(order))
  }, [ordersToUse])

  const { yesObjects: transferOrders }: { yesObjects: TransferOrder[] } =
    useFetchYesObjects({
      filterBody: {
        objectclass: window.uuidObjectclassTransferorder || '',
        query: {
          $and: [
            {
              'checkpoint.uuid': {
                $in: checkpoints?.map((c) => c.uuid)
              }
            }
          ]
        },
        project_fields: {
          ...(ordersToUse.length > 0 && {
            ...Object.fromEntries(ordersToRemove?.map((order) => [order, 0]))
          })
        }
      },
      enabled: !!checkpoints?.length
    })

  const statuses = useStatuses({
    objectclassUuid: window.uuidObjectclassCheckpoint
  })

  const getStatus = (statusCode: string): StatusObject | undefined => {
    return statuses.find((status) => status.code === statusCode)
  }

  if (!checkpoints?.length) {
    return null
  }

  return (
    <CollapsibleCard
      hierarchyCardLevel={1}
      heightClass='extraSmall'
      areaLineProps={{
        style: { backgroundColor: '#004099' }
      }}
      centerHeaderElement={
        <SectionTitle>{t('transport-card.checkpoints')}</SectionTitle>
      }
    >
      <Container>
        {checkpoints.map((checkpoint) => (
          <CheckpointCard
            key={checkpoint.uuid}
            checkpoint={checkpoint}
            status={getStatus(checkpoint.uuid_status)}
            transferOrders={transferOrders}
          />
        ))}
      </Container>
    </CollapsibleCard>
  )
}

export default CheckpointsSection
